import type { TestListItemDto } from '@flowqa/shared';

export const resolveTestRunChildCount = (
  row: Pick<TestListItemDto, 'executionStatusCounts' | 'executionSummaries'>,
): number => row.executionStatusCounts?.total ?? row.executionSummaries?.length ?? 0;
